export default __webpack_public_path__ + "static/media/results.26eebed9.svg";